import { render, staticRenderFns } from "./TopicListControl.vue?vue&type=template&id=316def93&"
import script from "./TopicListControl.vue?vue&type=script&lang=js&"
export * from "./TopicListControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports